<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <!-- <a-row :gutter="24"></a-row> -->
        <a-row :gutter="24">
          <a-col :span="10">
            <a-form-model-item label="领用时间">
              <!-- <j-select-device-class :multiple="false" placeholder="请选择设备类型" v-model="queryParam.devClassId" /> -->
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
                format="YYYY-MM-DD"
                v-model="queryParam.adoptionTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="任务类型">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="bpbj-task-type"
                placeholder="请选择任务类型"
                type="checkbox"
                v-model="queryParam.taskTable"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="4" :sm="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('备品备件出库领用单')" icon="download" type="primary">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="small"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <template slot="repairPlanId" slot-scope="text, record">
          <a @click="jumpto(record)">{{text}}</a>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
        </span>
      </a-table>
    </div>

    <!-- 备件出库 详情页面 -->
    <dev-bpbj-leadout-record-modal @ok="modalFormOk" ref="modalForm"></dev-bpbj-leadout-record-modal>

    <!-- 保养计划查看页面 -->
    <task-device-modal :canEdit="false" @ok="modalFormOk" ref="taskDevice"></task-device-modal>

    <!-- 消缺记录查看页面 -->
    <def-handle-list ref="defHandleList"></def-handle-list>

    <!-- 日常检修记录查看页面 -->
    <yw-daily-overhaul-task-execute-modal @ok="modalFormOk" ref="overhaul" />
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { getAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevBpbjLeadoutRecordModal from './modules/DevBpbjLeadoutRecordModal'
  import TaskDeviceModal from '@/views/eMaintenance/modules/TaskDeviceModal'
  import DefHandleList from '@/views/equipment/defect/vue/DefHandleList'
  import YwDailyOverhaulTaskExecuteModal from '@/views/maintenance/overhaul/modules/YwDailyOverhaulTaskExecuteModal'
  import { filterObj } from '@/utils/util';

  export default {
    name: 'DevBpbjLeadoutRecordList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevBpbjLeadoutRecordModal,
      TaskDeviceModal,
      DefHandleList,
      YwDailyOverhaulTaskExecuteModal,
    },
    data () {
      return {
        description: '备品备件出库领用单管理页面',
        queryParam: {},
        isorter: {
          column: 'adoptionTime',
          order: 'desc'
        },
        // 表头
        columns: [

          {
            title: '领用单编码',
            align: 'center',
            dataIndex: 'adoptionCode',
            sorter: true,
          },
          {
            title: '领用时间',
            align: 'center',
            dataIndex: 'adoptionTime',
            sorter: true,
          },
          {
            title: '领用总金额',
            align: 'center',
            dataIndex: 'totalAmount',
            sorter: true,
          },

          {
            title: '领用人',
            align: 'center',
            dataIndex: 'adopterName'
          },
          {
            title: '任务类型',
            align: 'center',
            dataIndex: 'taskTable_dictText',
            sorter: true,
          },
          {
            title: '任务ID',
            align: 'center',
            dataIndex: 'repairPlanId',
            scopedSlots: { customRender: 'repairPlanId' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/spareparts/devBpbjLeadoutRecord/list',
          delete: '/spareparts/devBpbjLeadoutRecord/delete',
          deleteBatch: '/spareparts/devBpbjLeadoutRecord/deleteBatch',
          exportXlsUrl: '/spareparts/devBpbjLeadoutRecord/exportXls',
          importExcelUrl: 'spareparts/devBpbjLeadoutRecord/importExcel',

          bizList: {
            overhaul: '/maintenance/overhaul/list',
            maintain: '/maintenance/devMaintainceTask/list',
          }
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      onDateChange (value, dateString) {
        this.queryParam.adoptionTime_begin = dateString[0] + ' 00:00:00';
        this.queryParam.adoptionTime_end = dateString[1] + ' 23:59:59';
        this.searchQuery();
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'adoptionCode', text: '领用单编码' })
        fieldList.push({ type: 'date', value: 'adoptionTime', text: '领用时间' })
        fieldList.push({ type: 'number', value: 'totalAmount', text: '领用总金额' })
        fieldList.push({ type: 'string', value: 'adopterId', text: '领用人' })
        fieldList.push({ type: 'string', value: 'adopterName', text: '领用人名称' })
        fieldList.push({ type: 'date', value: 'registerTime', text: '登记时间' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注' })
        fieldList.push({ type: 'string', value: 'taskTable', text: '任务来源表' })
        fieldList.push({ type: 'string', value: 'repairPlanId', text: '检修计划ID' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      },
      getQueryParams () {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        delete param.adoptionTime; // 时间参数不传递后台
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      jumpto (record) {
        const data = JSON.parse(JSON.stringify(record));
        data.id = data.repairPlanId
        // 缺陷页面：写死 “defect”
        // 保养页面： 写死 "maintain
        // 检修页面：  写死  overhaul
        if (data.taskTable == 'maintain') {
          getAction(this.url.bizList.maintain, { id: record.repairPlanId }).then((res) => {
            if (res.success) {
              this.$refs.taskDevice.edit(res.result.records[0])
              this.$refs.taskDevice.title = '保养清单'
              this.canEdit = false
              this.$refs.taskDevice.disableSubmit = true
            } else {
              this.$message.warning(res.message)
            }
          });
        } else if (data.taskTable == 'overhaul') {
          getAction(this.url.bizList.overhaul, { id: record.repairPlanId }).then((res) => {
            if (res.success) {
              this.$refs.overhaul.edit(res.result.records[0])
              this.$refs.overhaul.title = '检修报告'
              this.$refs.overhaul.disableSubmit = true
            } else {
              this.$message.warning(res.message)
            }
          });
        } else if (data.taskTable == 'defect') {
          this.$refs.defHandleList.init(data.id)
        }
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
